export enum PUNKU_ACTIONS {
  CONSULTAR = 'CON',
  MODIFICAR = 'MOD',
  AGREGAR = 'AGR',
  ELIMINAR = 'ELI',
  EJECUTAR = 'EJE',
  ACCEDER = 'ACC'
};
